import React, { useState } from 'react';
import { QuestRoute } from '../../api/QuestRoutes';
import styled from 'styled-components';
import Button from '../../forms/Button';
import GetState from '../../GetState';

const Wrapper = styled.div`
    position: relative;
    display: flex;
    height: auto;
    margin-bottom: 1em;
    padding: 1em;
    box-shadow: rgba(0, 0, 0, 0.16) 0px 3px 10px;
    border-radius: 1em;
    white-space: pre-wrap;
`
const AnswerWrap = styled.p`
    border-bottom: 1px solid rgba(137,137,137,1);
    font-size: .9em;
`
const DateLine = styled.span`
    font-size: 0.6em;
    color: grey;
`

const UserSurveys = ({ customerId, ...props }) => {

    const [userSurveys] = GetState(QuestRoute.surveys(customerId));
    const [hideResponses, setHideResponses] = useState(false);
    
    const updateShowHide = Array.isArray(userSurveys) ? new Array(userSurveys.length).fill(false) : false; 
    const showHideResponses = (index, hideShow) => {
        updateShowHide[index] = !hideShow;
        setHideResponses(updateShowHide);
    }
     return (
        <>
            {
                Array.isArray(userSurveys) ?
                    userSurveys.length != 0 ?
                userSurveys.map((ques, i) => (
                    <Wrapper key={i}>
                        <span>
                            <h5>{ques.question}</h5>
                            {<Button onClick={ () => showHideResponses(i, (hideResponses[i] ? true : false)) } 
                                    label={ (hideResponses[i] ? 'Hide' : 'Show') + ' Responses'} /> }
                                { hideResponses[i] &&  
                                ques.responses
                                    .map((resp, index) => (
                                        <>
                                            <AnswerWrap key={index}>
                                                <DateLine>{new Date(resp.submittedAt).toLocaleDateString()}</DateLine> <br />
                                                {resp.customerResponse} </AnswerWrap>                              
                                        </>
                                    ))}
                        </span>
                    </Wrapper>
                )) : <Wrapper>No Surveys</Wrapper>
                : <Wrapper>No Surveys</Wrapper>
            }
            
        </>
    ); 
}

export default UserSurveys;
